import React, { FC, useState } from 'react';
import useDevice from '@/hooks/useDevice';
import Box from '@/components/UI/box/Box';
import Footer from '@/components/layout/footer/Footer';
import HousesMobile from '@/components/houses/housesMobile/HousesMobile';
import HousesDesktop from '@/components/houses/housesDesktop/HousesDesktop';
import ProductMeta from '@/components/houses/productMeta/ProductMeta';
import Header from '../layout/header/Header';
import FastLoginContainer from '@/components/houses/fastLoginContainer/FastLoginContainer';
import NonBookable from '@/components/houses/nonBookable/NonBookable';
import { ProductItemTypes } from './_types/productItem.types';
import styles from './Houses.module.scss';
import { useIsWhiteLabel } from '../app/providers/whiteLabelProvider/WhiteLabelProvider';
import { useRouter } from 'next/router';
import Image from 'next/image';
import SafarMarketBanner from '../home/whiteLabelBanner/safarMarketBanner/SafarMarketBanner';
type HousesProps = {
  mainUrl: string;
  data: ProductItemTypes;
  host: string;
};
const Houses: FC<HousesProps> = ({
  data,
  mainUrl,
  host
}) => {
  const router = useRouter();
  const {
    isMobile
  } = useDevice();
  const isNonBookable = data?.bookable_status === 'non_bookable';
  const [nonBookableOpen, setNonBookableOpen] = useState(isNonBookable);
  const isWhiteLabel = useIsWhiteLabel();
  const safarmarketId = router.query.safarmarketId;
  return <>
      {safarmarketId && <SafarMarketBanner />}
      <ProductMeta productState={data as ProductItemTypes} url={mainUrl as string} host={host as string} data-sentry-element="ProductMeta" data-sentry-source-file="Houses.tsx" />
      <Box className={`${styles['main-container']} ${nonBookableOpen ? styles['non-bookable'] : ''}`} data-sentry-element="Box" data-sentry-source-file="Houses.tsx">
        {isMobile ? <HousesMobile data={data} host={host} /> : <>
            <Header defaultLightMode id={data?.id} />
            <HousesDesktop data={data} host={host} />
          </>}
      </Box>
      {!isWhiteLabel && <Footer />}
      <FastLoginContainer data-sentry-element="FastLoginContainer" data-sentry-source-file="Houses.tsx" />
      {isNonBookable && nonBookableOpen && <NonBookable setOpen={setNonBookableOpen} />}
      {safarmarketId && <Image src={`https://safarmarket.com/api/stay/v1/pixel/shab/2/0/?smId=${safarmarketId}`} style={{
      width: '1px',
      height: '1px',
      opacity: 0
    }} alt="safarmarket" width={1} height={1} />}
    </>;
};
export default Houses;